import React from 'react'
import styled from 'styled-components'
import { useDragOperation, useDroppable } from '@dnd-kit/react'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

export const END_DROP_ZONE_ID = '__end__'

type Props = {
  fillsEmptyCell: boolean
}

const EndDropZone = ({ fillsEmptyCell }: Props) => {
  const droppable = useDroppable({ id: END_DROP_ZONE_ID })
  const { source } = useDragOperation()

  if (!source) return null

  return (
    <S.Wrapper ref={droppable.ref} $fillsEmptyCell={fillsEmptyCell}>
      {droppable.isDropTarget && (
        fillsEmptyCell ? <S.VerticalDropIndicator /> : <S.HorizontalDropIndicator />
      )}
    </S.Wrapper>
  )
}

export default EndDropZone

const S = {
  Wrapper: styled.div<{ $fillsEmptyCell: boolean }>`
    position: relative;
    grid-column: span ${({ $fillsEmptyCell }) => $fillsEmptyCell ? 1 : 2};
    ${({ $fillsEmptyCell }) => $fillsEmptyCell ? '' : 'height: 24px;'}

    @media ${screenSize.large} {
      grid-column: span 1;
      height: 24px;
    }
  `,
  VerticalDropIndicator: styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: -7px;
    width: 4px;
    border-radius: 2px;
    background-color: ${color('draggableDropIndicator')};
    z-index: 3;
    pointer-events: none;

    @media ${screenSize.large} {
      top: 50%;
      bottom: auto;
      left: 0;
      right: 0;
      width: auto;
      height: 4px;
      margin-top: -2px;
    }
  `,
  HorizontalDropIndicator: styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 4px;
    margin-top: -2px;
    border-radius: 2px;
    background-color: ${color('draggableDropIndicator')};
    z-index: 3;
    pointer-events: none;
  `
}
